import React from 'react';
import { BookOpenIcon, DocumentTextIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

export default function UsefulResources() {
  const articles = [
    {
      title: "How Startup Founders Can Deliver Bad News To Their Teams",
      url: "https://blog.manahwellness.com/how-startup-founders-can-break-bad-news-to-their-teams/",
      description: "A guide on effectively communicating difficult news to your team"
    },
    {
      title: "Buffer CEO 'Why I don't shield my team from bad news'",
      url: "https://buffer.com/resources/sharing-bad-news/",
      description: "Insights on transparency and open communication from Buffer's CEO"
    }
  ];

  const templates = [
    {
      title: "5 Whys Root Cause Analysis [miro template]",
      url: "https://miro.com/templates/5-whys/",
      description: "A template for conducting root cause analysis"
    },
    {
      title: "Lean Change Canvas [downloadable template]",
      url: "https://canvanizer.com/new/lean-change-canvas",
      description: "A framework for managing organizational change"
    }
  ];

  const frameworks = [
    {
      title: "Redhat's Open Decision Making Framework",
      url: "https://github.com/red-hat-people-team/open-decision-framework/blob/master/ODF-community.pdf",
      description: "A comprehensive framework for transparent decision-making"
    },
    {
      title: "Rules for Making Mistakes at Runa",
      url: "https://www.notion.so/30507202aaf4483aa448326c8315f6e7",
      description: "Guidelines for handling mistakes in a constructive way"
    }
  ];

  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Useful Resources"
        icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />}
        heading="Tools, templates, and frameworks to help you navigate through challenges"
      >
        <div className="grid gap-6 md:grid-cols-2">
          <PlaybookCard>
            <div className="flex items-center mb-4">
              <DocumentTextIcon className="h-6 w-6 text-primary-light mr-3" />
              <h2 className="text-xl font-semibold text-white">Articles & Guides</h2>
            </div>
            <ResourceList items={articles} />
          </PlaybookCard>

          <PlaybookCard>
            <div className="flex items-center mb-4">
              <WrenchScrewdriverIcon className="h-6 w-6 text-primary-light mr-3" />
              <h2 className="text-xl font-semibold text-white">Templates & Tools</h2>
            </div>
            <ResourceList items={templates} />
          </PlaybookCard>

          <PlaybookCard className="md:col-span-2">
            <div className="flex items-center mb-4">
              <WrenchScrewdriverIcon className="h-6 w-6 text-primary-light mr-3" />
              <h2 className="text-xl font-semibold text-white">Frameworks & Methodologies</h2>
            </div>
            <ResourceList items={frameworks} />
          </PlaybookCard>
        </div>
      </PlaybookSection>
    </div>
  );
} 